import React, { useState } from 'react';

import MobileFab from 'components/Layout/MobileShell/MobileFab';
import MobileListState from 'components/Layout/MobileShell/MobileListState';
import CloseButton from 'components/CloseButton';
import { ResponseError } from 'services/api/base';
import { useListMailerOptionTypesQuery } from 'services/api/mailer';
import useHandleRequestErrors from 'utils/hooks/useHandleRequestErrors';
import AlertsCollection, { CustomAlert } from 'components/AlertsCollection';
import TemplateForm from 'components/Admin/Mailer/Templates/Form';
import { SelectedTemplate } from 'components/Admin/Mailer/Templates/TemplateList/List/Item/EditButton';

import TemplateCard from './TemplateCard';

import './index.scss';

export default function TemplateListMobile({
  openNewTemplateForm,
}: {
  openNewTemplateForm: () => void,
}) {
  const { data: types, isLoading: typesLoading, error } = useListMailerOptionTypesQuery();
  const [editing, setEditing] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<SelectedTemplate | null>(null);
  const [alerts, setAlerts] = useState<CustomAlert[]>([]);

  useHandleRequestErrors(error as ResponseError);

  // No mobile a edição abre em página cheia (não em FormModal, que fica espremido),
  // reaproveitando o mesmo TemplateForm da criação — só que pré-preenchido.
  if (editing && selectedTemplate) {
    return (
      <div className="templates-mobile-form">
        <CloseButton
          id="close-edit-template"
          label="Editar Template"
          onClick={() => setEditing(false)}
        />
        <TemplateForm
          types={types}
          typesLoading={typesLoading}
          templateType={selectedTemplate.type}
          templateSubtype={selectedTemplate.subType}
        />
      </div>
    );
  }

  const hasTemplates = !!types?.some((type) => type.subTypes.length > 0);

  return (
    <div className="templates-mobile">
      <AlertsCollection alerts={alerts} />

      <MobileListState
        loading={typesLoading}
        isEmpty={!hasTemplates}
        emptyMessage="Nenhum template cadastrado."
      >
        {types?.map((type) => type.subTypes.map((subType) => (
          <TemplateCard
            key={`${type.id}-${subType.id}`}
            type={type}
            subType={subType}
            setModalOpen={setEditing}
            setSelectedTemplate={setSelectedTemplate}
            setAlerts={setAlerts}
          />
        )))}
      </MobileListState>

      <MobileFab label="Novo template" onClick={openNewTemplateForm} />
    </div>
  );
}
